export default {
  defaultRoute: { name: 'homepage' },
};
